import styled from "styled-components";

export const Container = styled.div`
  padding: 2rem;
`;

export const TableSearchLocations = styled.form`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
  max-width: 400px;

  .table-search-locations {
    margin: 0;
  }
`;
